import { TextField, InputAdornment, Stack, Button } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search';
import { useState } from "react"
import Layout from "../../Frames/Layout"
import API from "../../../services/API/Rewards"
import Loader from '../../Tools/Loader'
import Toast from '../../Tools/Toast'
import { useMemo } from "react";
import { Link } from "react-router-dom";
import Reward from "./Reward";
import { useQuery } from "react-query";

export default function List(){

    const [error, setError] = useState(false)
    const [search, setSearch] = useState('')

    const q = useQuery('rewards', () => API.getAll().then(r => r.data))

    const list = useMemo(() => 
        (q.isSuccess ? q.data : [])
            .filter(i => i.title.toLowerCase().includes(search.toLowerCase()))
            .sort((a,b) => a.title > b.title ? 1 : -1)
    , [q, search])


    return <Layout title="Récompenses" tab="rewards" menu="marketing" >

        <Stack direction='row' justifyContent='space-between' alignItems='center' sx={{mb: 1}}>

            <TextField
                label='Rechercher'
                type='search'
                size='small'
                value={search}
                onChange={e => setSearch(e.target.value)}
                InputProps={{
                    startAdornment: <InputAdornment position='start'><SearchIcon/></InputAdornment>
                }}
                sx={{mb: 2}}
            />

            <Link to={`/marketing/rewards/new`}>
                <Button variant='contained'>Ajouter</Button>
            </Link>
            
        </Stack>

        <Stack direction='row' alignItems='stretch' sx={{flexWrap: 'wrap'}}>

            {list.map(i => 
                <Reward 
                    reward={i}
                    key={i.id}
                />
            )}

        </Stack>

        {q.isLoading && <Loader/>}
        
        <Toast
            open={error}
            severiry='error'
            message="Une erreur s'est produite, les données n'ont pas pu être chargées"
            onClose={() => setError(false)}
        />

    </Layout>
}